module.exports = __webpack_public_path__ + "media/images/png/rent-white/3-2ef90a77cc4d280bf6c5eda2fc8cd9a1.png";